import { render } from "./ChangeTopicStatusPopup.vue?vue&type=template&id=35fb941b&scoped=true"
import script from "./ChangeTopicStatusPopup.vue?vue&type=script&lang=js"
export * from "./ChangeTopicStatusPopup.vue?vue&type=script&lang=js"

import "./ChangeTopicStatusPopup.vue?vue&type=style&index=0&id=35fb941b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35fb941b"]])

export default __exports__